module.exports = __webpack_public_path__ + "img/PIE_CHART.19187c9c.svg";